import { DataSources } from '@leverege/ui-attributes'
import React, { useCallback, useMemo, useState } from 'react'
import { DateTime } from 'luxon'
import { Flex, ToggleButton } from '@leverege/ui-elements'

import EventsEnabledItemDelegate from '../../events/EventsEnabledItemDelegate'
import AisleImage from '../components/AisleImage'

import S from './AisleHeatmapImageRenderer.css'

export default function AisleHeatmappingImageRenderer( props ) {
  const { value, object } = props

  const [ selectedRange, setSelectedRange ] = useState( 'pastWeek' )

  const RANGES = useMemo( () => {
    const now = DateTime.now()

    return {
      yesterday : {
        start : now
          .minus( { day : 1 } )
          .startOf( 'day' )
          .toISO(),
        end : now
          .minus( { day : 1 } )
          .endOf( 'day' )
          .toISO(),
        name : 'yesterday'
      },
      pastWeek : {
        start : now
          .minus( { days : 7 } )
          .startOf( 'day' )
          .toISO(),
        name : 'pastWeek'
      },
      past30Days : {
        start : now
          .minus( { days : 30 } )
          .startOf( 'day' )
          .toISO(),
        name : 'past30Days'
      }
    }
  }, [] )

  const delegate = useMemo( () => {
    const d = DataSources.getDelegate( object )

    return new EventsEnabledItemDelegate( {
      match : d.match,
      relationship : d.relationship
    } )
  }, [ object ] )

  const onChangeRange = useCallback( ( { data } ) => {
    setSelectedRange( data )
  }, [] )

  return (
    <Flex variant="colS">
      <RangeSelector value={selectedRange} onChange={onChangeRange} />
      <AisleImage
        item={object}
        delegate={delegate}
        src={value}
        range={RANGES[selectedRange]} />
    </Flex>
  )
}

function RangeSelector( props ) {
  const { value, onChange } = props

  return (
    <Flex direction="row" className={S.toggleContainer}>
      <ToggleButton
        eventData="yesterday"
        className={S.toggle}
        onChange={onChange}
        value={value === 'yesterday'}
        variant="radioSelectorFirst">
        Yesterday
      </ToggleButton>
      <ToggleButton
        eventData="pastWeek"
        className={S.toggle}
        onChange={onChange}
        value={value === 'pastWeek'}
        variant="radioSelector">
        Past Week
      </ToggleButton>
      <ToggleButton
        eventData="past30Days"
        className={S.toggle}
        onChange={onChange}
        value={value === 'past30Days'}
        variant="radioSelectorLast">
        Past Month
      </ToggleButton>
    </Flex>
  )
}
